import {Grid} from '@logistics-frontend/blocks'
import {CircularProgress} from '@logistics-frontend/blocks/legacy'
import {AdaptiveDialog, DialogContent, DialogTitleWithClose} from '@logistics-frontend/blocks/lpc/dialog'
import {Divider} from '@logistics-frontend/blocks/lpc/divider'
import {ChevronRightIcon} from '@logistics-frontend/blocks/lpc/icons'
import {Buttonv2 as Button, Typographyv2 as Typography} from '@logistics-frontend/blocks/v2'
import {useI18n} from '@logistics-frontend/core/i18n'
import {AsyncStatus, useCoupon, useCouponListQuery} from '@yandex-taxi/react-integration-api'
import React, {useState} from 'react'

import Coupon from './Coupon'
import CouponActivationField from './CouponActivationField'
import {classes} from './CouponsField.classes'

const Coupons: React.FC = () => {
  const t = useI18n()
  const {data, status} = useCouponListQuery()
  const [{value: couponValue}] = useCoupon()
  const [isOpen, setOpen] = useState(false)
  const openHandler = () => setOpen(true)
  const closeHandler = () => setOpen(false)
  const coupons = data?.coupons || []
  const isIdleOrError = status === AsyncStatus.INITIAL || status === AsyncStatus.ERROR
  const isSuccess = status === AsyncStatus.SUCCESS
  const isNotSuccess = !isSuccess
  const isPending = status === AsyncStatus.PENDING

  return (
    <>
      <Grid
        alignItems="center"
        className={classes.couponButton}
        component="button"
        disabled={isNotSuccess}
        onClick={openHandler}
        wrap="nowrap"
        container
      >
        <Typography className={classes.titleText} variant="caption1">
          {t('order.form.coupons.title', 'Промокоды')}
        </Typography>
        <Grid alignItems="center" className={classes.couponStatusTitle} justify="flex-end" wrap="nowrap" item>
          {isSuccess ? (
            <>
              <Typography className={classes.statusText} thickness="regular" variant="body2">
                {couponValue || t('order.form.coupons.new', 'Новый промокод')}
              </Typography>
              <div className={classes.icon}>
                <ChevronRightIcon />
              </div>
            </>
          ) : isIdleOrError ? (
            <Typography className={classes.statusText} thickness="regular" variant="body2">
              {t('order.form.coupons.loading_error', 'Не удалось загрузить промокоды')}
            </Typography>
          ) : (
            <CircularProgress />
          )}
        </Grid>
      </Grid>
      <Divider />
      <AdaptiveDialog maxWidth="xs" onClose={closeHandler} open={isOpen} fullWidth>
        <DialogTitleWithClose onClose={closeHandler} littleCloseIcon>
          {t('order.form.coupons.dialog_title', 'Промокоды')}
        </DialogTitleWithClose>
        <DialogContent>
          {isSuccess && coupons.map((coupon, index) => <Coupon key={index} coupon={coupon} />)}
          {isPending && <CircularProgress />}
          <CouponActivationField />
          <Button className={classes.closeButton} onPress={closeHandler} variant="default" fullWidth>
            {t('order.form.coupons.dialog_close', 'Закрыть')}
          </Button>
        </DialogContent>
      </AdaptiveDialog>
    </>
  )
}

export default Coupons
